import React from 'react'
import { useSelector } from 'react-redux'
import SupplyBillItemOne from './SupplyBillItemOne'
import SupplyBillItemAgreesAll from '../forms/agreesAll/SupplyBillItemAgreesAll'

const SupplyBillItemList = () => {

    const supplyBill = useSelector(state => state.supplyBill.supplyBill)

  return (
    <div>
        {
            supplyBill.items && supplyBill.items.length > 0 ?
                <>
                    <SupplyBillItemAgreesAll 
                        supplyBillId={supplyBill.id}
                        supplyBillItems={supplyBill.items}
                    />
                    {
                        supplyBill.items.map((supplyBillItem, index) => 
                            <SupplyBillItemOne
                                key={supplyBillItem.id}
                                index={index}
                                supplyBillItem={supplyBillItem} 
                                // checked={checked}
                                // setChecked={setChecked}
                            />
                        )
                    }
                </>
            : 
                <p>Позицій не знайдено</p>
        }
    </div>
  )
}

export default SupplyBillItemList